import React, { useEffect, useRef } from "react";
import { Button, CloseIconButton } from "@tripian/react";
import moment from "moment";
import QRCode from "react-qr-code";
import useTranslate from "../../hooks/useTranslate";
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";
import classes from "./ShareTripModal.module.scss";

interface IGuestShareModal {
  cityName?: string;
  arrivalDatetime?: string;
  departureDatetime?: string;
  tripUrl: string;
  onCancel: () => void;
  onMountShare?: () => void;
}

const GuestShareModal: React.FC<IGuestShareModal> = ({
  cityName,
  arrivalDatetime,
  departureDatetime,
  tripUrl,
  onCancel,
  onMountShare,
}) => {
  const { copySuccess, copyToClipBoard } = useCopyToClipboard();
  const { t } = useTranslate();

  const tripArrivalDatetimeMoment = moment(arrivalDatetime).utcOffset(0);
  const tripDepartureDatetimeMoment = moment(departureDatetime).utcOffset(0);

  const calledRef = useRef(false);
  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;
    if (onMountShare) {
      onMountShare();
    }
  }, [onMountShare]);

  return (
    <div className={classes.shareModal}>
      <div className={classes.dialog}>
        <div className="flex items-center justify-end w-full pr-2 mt-2">
          <CloseIconButton
            className="w-6 h-6"
            fill="#2B2B33"
            clicked={onCancel}
          />
        </div>

        <div>
          <div className="flex items-center justify-center font-bold text-xl mr-1">
            {cityName}
          </div>
          <div className="flex items-center justify-center ml-1 text-lg">{`${tripArrivalDatetimeMoment.format("MMMM DD")}-${tripDepartureDatetimeMoment.format(
            "DD"
          )}, ${tripDepartureDatetimeMoment.format("YYYY")}`}</div>

          <div className="px-4">
            <hr className="h-px my-4 bg-gray-400 border-0" />
          </div>

          <div className="flex items-center justify-center my-8">
            <div className="bg-white p-4 rounded-lg shadow-md border">
              <QRCode value={tripUrl} size={128} />
            </div>
          </div>

          <div className="flex items-center justify-center w-full px-4">
            <Button
              color="primary"
              className="w-full rounded-3xl"
              onClick={() => copyToClipBoard(tripUrl)}
              text={
                copySuccess
                  ? t("trips.shareTrip.copiedLink")
                  : t("trips.shareTrip.copyLink")
              }
            />
          </div>
          <div className="flex items-center justify-center my-2 text-sm">
            <div className="text-lg pt-1 mr-1">*</div>
            <div>{t("trips.shareTrip.description")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestShareModal;
